import React, { Component } from "react"
import { connect } from "react-redux"
import { Body } from "../Shell/Shell"
import { Link } from "react-router-dom"
import ExpandableCard from "components/ExpandableCard/ExpandableCard"
import { ConfirmDialog } from 'components/Modal/Modal'
import ReactTooltip from "react-tooltip"
import CaretDownIcon from "@tecuity/sos-icons/react/caret-down"
import CaretUpIcon from "@tecuity/sos-icons/react/caret-up"
import PencilIcon from "@tecuity/sos-icons/react/pencil"
import DotMenuIcon from "@tecuity/sos-icons/react/dot-menu"
import TrashIcon from "@tecuity/sos-icons/react/trash"
import ICONS from "components/Icons/Icons"
import Portal from 'components/Portal/Portal'
import { Modal } from "components/Modal/Modal"
import { DumbField } from "components/Wizard2/Field"
import { TextInput, Checkbox, Select } from "components/Wizard2/fieldComponents/Form"
import {
  getAndSetCartQuantity
} from '../../actions'
import {
  getHomeStructure,
  updateAndPushCategories,
  getSystemMessage,
  updateAndPushSystemMessage,
  updateAndPushFoldLinks
} from "./HomeActions"
import { MarkdownHint } from "components/Designer2/TextEditor"
import ReactMarkdown from "components/Markdown/Markdown"
import FloatingMenu from "components/FloatingMenu/FloatingMenu"
import QuickLinksEditor from './QuickLinksEditor'
import "./Home.scss"
import AddCategoryCard from "../AddCategoryCard/AddCategoryCard"
import shortid from 'shortid'

class Home extends Component {
  componentDidMount = () => {
    this.getHomeStructure()
    this.getSystemMessage()
    this.getAndSetCartQuantity()
  }
  getAndSetCartQuantity = () => {
    this.props.getAndSetCartQuantity()
  }
  getHomeStructure = () => {
    this.props.getHomeStructure()
  }
  getSystemMessage = () => {
    this.props.getSystemMessage()
  }
  addCategory = category => {
    this.props.updateAndPushCategories([
      ...this.props.rawStructure.categories,
      { ...category, id: shortid.generate() }
    ])
  }
  deleteCategory = index => {
    this.props.updateAndPushCategories([
      ...this.props.rawStructure.categories.slice(0, index),
      ...this.props.rawStructure.categories.slice(index + 1)
    ])
  }
  updateCategoryByIndex = ({ index, category }) => {
    this.props.updateAndPushCategories([
      ...this.props.rawStructure.categories.slice(0, index),
      { ...this.props.rawStructure.categories[index], ...category },
      ...this.props.rawStructure.categories.slice(index + 1)
    ])
  }
  updateAndPushSystemMessage = message => {
    this.props.updateAndPushSystemMessage(message)
  }
  updateAndPushFoldLinks = links => {
    this.props.updateAndPushFoldLinks(links)
  }
  render() {
    const { categories, foldLinks, systemMessage, loggedInAsAdmin, rawStructure } = this.props
    return (
      <Body className="no-padding home">
        <div className="header-row">
          <h1>{process.env.HOME_TITLE || process.env.SYSTEM_NICKNAME}</h1>
          <span className="subtitle">
            {process.env.HOME_SUBTITLE || `${process.env.STATE_NAME} ${process.env.STATE_ORG_TITLE}`}
          </span>
          <SystemMessage
            onChange={this.updateAndPushSystemMessage}
            message={systemMessage}
            allowEdit={loggedInAsAdmin}
          />
          <div className="shade" />
        </div>
        <FoldLinks links={foldLinks} allowEdit={loggedInAsAdmin} onChange={this.updateAndPushFoldLinks} />
        <CategoryCards
          updateCategoryByIndex={this.updateCategoryByIndex}
          addCategory={this.addCategory}
          categories={categories}
          rawCategories={rawStructure.categories}
          deleteCategory={this.deleteCategory}
        />
        <div className={"img-shade"} />
      </Body>
    )
  }
}
export default connect(
  state => ({
    categories: state.home.categories,
    foldLinks: state.home.foldLinks,
    systemMessage: state.home.systemMessage,
    loggedInAsAdmin:
      state.auth.loggedIn &&
      (state.auth.USER_GROUP === "ADMIN" ||
        state.auth.USER_GROUP === "ADMIN_WEB"),
    rawStructure: state.home.rawStructure
  }),
  {
    getHomeStructure,
    updateAndPushCategories,
    getSystemMessage,
    updateAndPushSystemMessage,
    updateAndPushFoldLinks,
    getAndSetCartQuantity
  }
)(Home)

class SystemMessage extends Component {
  state = {
    messageModalOpen: false,
    editText: ""
  }
  toggleEditModal = () => {
    this.setState(
      state => ({
        messageModalOpen: !state.messageModalOpen,
        editText: this.props.message || ""
      }),
      () => {
        if (this.state.messageModalOpen && this.editor) this.editor.focus()
      }
    )
  }
  setEditText = e => {
    this.setState({ editText: e.target.value })
  }
  setSystemMessage = () => {
    this.props.onChange(this.state.editText)
  }
  handleKeyDown = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      if (this.props.allowEdit) {
        this.toggleEditModal()
      }
    }
  }

  render() {
    const { message, allowEdit } = this.props
    return (
      <div className="home-message-wrapper" tabIndex="-1">
        {message && message !== "" ? (
          <div
            role={allowEdit ? "button" : ""}
            tabIndex={allowEdit ? "0" : ""} onKeyDown={this.handleKeyDown}
            className={`message ${allowEdit ? "editable" : ""}`}
            onClick={allowEdit ? this.toggleEditModal : undefined}
          >
            <div className="icon-wrapper">
              <span className="info-icon" aria-hidden="true">i</span>
              {allowEdit && <PencilIcon className="edit-icon" />}
            </div>
            <ReactMarkdown
              source={message}
              className="markdown text"
            />
            {
              this.props.allowEdit &&
              <span className="visually-hidden"> Click to edit this message.</span>
            }
          </div>

        ) : (
            allowEdit && (
              <button
                className="message-placeholder"
                onClick={this.toggleEditModal}
              >
                Add a system message
              </button>
            )
          )}
        {allowEdit && (
          <Portal isOpened={this.state.messageModalOpen}>
            <Modal
              title={`Edit System Message`}
              modalSize="large"
              saveAndCloseButton
              cancelButton
              save={this.setSystemMessage}
              closeModal={this.toggleEditModal}
            >
              <div className="text-editor-wrapper">
                <div className="left-wrapper">
                  <textarea
                    className="text-editor"
                    value={this.state.editText}
                    onChange={this.setEditText}
                    placeholder="System maintenance is scheduled for..."
                    ref={ref => {
                      this.editor = ref
                    }}
                  />
                  <MarkdownHint />
                </div>
                <div className="right-wrapper preview-message">
                  <div className="shade" />
                  <div className="message">
                    <div className="icon-wrapper">
                      <span className="info-icon">i</span>
                    </div>
                    <span className="text">
                      <ReactMarkdown
                        source={this.state.editText}
                        className="markdown"
                      />
                    </span>
                  </div>
                  <div className={"img-shade"} />
                </div>
              </div>
            </Modal>
          </Portal>
        )}
      </div>
    )
  }
}

class FoldLinks extends React.Component {
  state = {
    modalOpen: false
  }
  openEditModal = () => {
    this.setState({
      modalOpen: true
    })
  }
  closeEditModal = () => {
    this.setState({
      modalOpen: false
    })
  }
  saveLinks = () => {
    this.props.onChange(this.linkEditor.getLinks())
  }
  render() {
    const { links = [], allowEdit } = this.props
    return (
      <div className="atf-links">
        {links.map((link, i) => (
          <FoldLink {...link} key={i}>
            {link.label}
          </FoldLink>
        ))}
        {
          allowEdit &&
          <div className='link-wrapper'>
            <button className='' onClick={this.openEditModal} aria-label="Edit Links">
              <PencilIcon />
            </button>
          </div>
        }
        {allowEdit && (
          <Portal isOpened={this.state.modalOpen}>
            <Modal
              title={`Edit Quick Links`}
              modalSize="large"
              saveAndCloseButton
              cancelButton
              save={this.saveLinks}
              closeModal={this.closeEditModal}
              bodyColor='light-neutral'
            >
              <QuickLinksEditor links={links} ref={r => { this.linkEditor = r }} />
            </Modal>
          </Portal>
        )}
      </div>
    )
  }
}

class FoldLink extends React.Component {
  render() {
    const { children, href = "", themeColor = '', targetBlank } = this.props
    return (
      <div className={`link-wrapper ${themeColor}`}>
        {href.startsWith("http") ||
          href.startsWith("www") ||
          href.endsWith(".com") ||
          href.endsWith(".gov") ? (
            <a href={href} target={targetBlank ? "blank" : undefined}>
              {children}
            </a>
          ) : (
            <Link to={href} target={targetBlank ? "blank" : undefined}>
              {children}
            </Link>
          )}
      </div>
    )
  }
}

class CategoryCards extends React.Component {
  render() {
    const { categories, updateCategoryByIndex, loggedInAsAdmin, rawCategories, addCategory, deleteCategory } = this.props
    const filteredCategories = categories.filter(c => !c.disabled || loggedInAsAdmin);
    const filteredRawCategories = rawCategories.filter(c => !c.disabled || loggedInAsAdmin);
    return (
      <div className="home-category-cards">
        {filteredCategories.map((category, i) => (
          <ExpandableCategoryCard
            {...category}
            updateCategoryByIndex={updateCategoryByIndex}
            index={i}
            key={category.id}
            rawCategory={filteredRawCategories[i]}
            deleteCategory={deleteCategory}
          />
        ))}
        {loggedInAsAdmin ?
          <AddCategoryCard onCategoryAdded={addCategory} />
          : null
        }
      </div>
    )
  }
}
CategoryCards = connect(state => ({
  loggedInAsAdmin:
    state.auth.loggedIn &&
    (state.auth.USER_GROUP === "ADMIN" || state.auth.USER_GROUP === "ADMIN_WEB")
}))(CategoryCards)

class ExpandableCategoryCard extends React.Component {
  render() {
    const {
      title,
      description,
      links = [],
      icon,
      disabled,
      id,
      index,
      updateCategoryByIndex,
      isMobile,
      rawCategory,
      deleteCategory
    } = this.props
    return (
      isMobile ?
        <CategoryCard
          className="home-category-card-wrapper"
          title={title}
          description={description}
          links={links}
          disabled={disabled}
          icon={icon}
          index={index}
          updateCategoryByIndex={updateCategoryByIndex}
          id={id}
          allowEdit
          rawCategory={rawCategory}
          deleteCategory={deleteCategory}
        />
        :
        <ExpandableCard
          className="home-category-card-wrapper"
          cardClassName="expandable-home-card"
          collapsedChildren={({ innerRef, expand }) => (
            <CategoryCard
              wrapperRef={innerRef}
              title={title}
              description={description}
              links={links}
              disabled={disabled}
              icon={icon}
              maxLinks={8}
              index={index}
              updateCategoryByIndex={updateCategoryByIndex}
              id={id}
              allowEdit
              rawCategory={rawCategory}
              deleteCategory={deleteCategory}
            >
              {links.length > 8 && (
                <button onClick={expand} className="expand-button" aria-label="View more links">
                  <CaretDownIcon />
                </button>
              )}
            </CategoryCard>
          )}
          expandedChildren={({ collapse }) => (
            <CategoryCard title={title} description={description} links={links} disabled={disabled} icon={icon} id={id}>
              <button onClick={collapse} className="expand-button" aria-label="View less links">
                <CaretUpIcon />
              </button>
            </CategoryCard>
          )}
        />
    )
  }
}
ExpandableCategoryCard = connect(
  state => ({
    isMobile: state.app.isMobile
  })
)(ExpandableCategoryCard)

class CategoryCard extends React.Component {
  state = {
    editModalOpen: false
  }
  toggleEditModal = () => {
    this.setState(state => ({ editModalOpen: !state.editModalOpen }))
  }
  getEditedCategoryFromModal = () => {
    const category = this.editModal.getValues()
    this.props.updateCategoryByIndex({ index: this.props.index, category })
  }
  handleKeyDown = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      if (this.props.loggedInAsAdmin && this.props.allowEdit) {
        this.toggleEditModal()
      }
    }
  }

  render() {
    const {
      wrapperRef,
      title,
      description,
      links,
      icon,
      disabled,
      id,
      children,
      maxLinks,
      loggedInAsAdmin,
      allowEdit,
      rawCategory,
      className = '',
      index,
      deleteCategory
    } = this.props

    return (
      <div ref={wrapperRef} className={`full-height ${className}`}>
        <div className={`home-category-card ${disabled ? 'disabled' : ''}`}>

          <div tabIndex="-1" >
            <div tabIndex={loggedInAsAdmin && allowEdit ? "0" : ""} className="link-wrapper" onKeyDown={this.handleKeyDown}>
              <h2
                role={allowEdit && loggedInAsAdmin ? "button" : ""}
                onClick={loggedInAsAdmin && allowEdit ? this.toggleEditModal : undefined}
                className={`${loggedInAsAdmin && allowEdit ? "admin" : ""}`}
              >
                <div className={`icon-wrapper`}>
                  {ICONS[icon]}
                  {loggedInAsAdmin &&
                    allowEdit && <PencilIcon className="edit-icon" />}
                </div>
                {title}
                {/* {hiddenTextH2s} */}
                {
                  this.props.allowEdit && loggedInAsAdmin &&
                  <span className="visually-hidden"> Click to edit this category.</span>
                }
              </h2>
            </div>
          </div>
          {description ? <ReactMarkdown className="markdown description" source={description} /> : null}
          <div className="links">
            {links.map(
              (link, i) =>
                link.type === "separator" ? (
                  process.env.HOME_HIDE_AUTH_HINT !== true ?
                    <Separator categoryId={id} key={i} />
                    : null
                ) : (
                    (!maxLinks || maxLinks > i) && (
                      link.label &&
                      (
                        link.href[0] !== '/' ?
                          <a href={link.href} target={link.targetBlank ? "_blank" : undefined} key={i}>{link.label}</a>
                          :
                          <Link
                            to={link.href}
                            target={link.targetBlank ? "_blank" : undefined}
                            key={i}
                          >
                            {link.label}
                          </Link>
                      )
                    )
                  )
            )}
          </div>
          {children}
        </div>
        {loggedInAsAdmin &&
          allowEdit && (
            <Portal isOpened={this.state.editModalOpen}>
              <Modal
                title={`Edit Category`}
                modalSize="large"
                saveAndCloseButton
                cancelButton
                save={this.getEditedCategoryFromModal}
                closeModal={this.toggleEditModal}
              >
                <EditCategoryModal
                  ref={ref => {
                    this.editModal = ref
                  }}
                  id={id}
                  title={rawCategory.title}
                  description={rawCategory.description}
                  links={rawCategory.links}
                  icon={rawCategory.icon}
                  disabled={disabled}
                  deletable={true}
                  onRequestDelete={() => deleteCategory(index)}
                />
              </Modal>
            </Portal>
          )}
      </div>
    )
  }
}
CategoryCard = connect(state => ({
  loggedInAsAdmin:
    state.auth.loggedIn &&
    (state.auth.USER_GROUP === "ADMIN" || state.auth.USER_GROUP === "ADMIN_WEB")
}))(CategoryCard)

const Separator = ({ categoryId }) => (
  <div className="home-separator-wrapper">
    <hr />
    <ReactTooltip effect="solid" place="top" id={`auth-hint-${categoryId}`} />
    <span
      className="icon icon-lock auth-hint"
      data-tip={process.env.HOME_LOGIN_HINT || "LOGIN REQUIRED"}
      data-for={`auth-hint-${categoryId}`}
    />
  </div>
)

export class EditCategoryModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title: props.title,
      description: props.description,
      links: props.links,
      icon: props.icon,
      disabled: props.disabled || false,
      iconMenuOpen: false,
      iconMenuAnchor: null,
      newIconIndex: null,
      deleteDialogOpen: false
    }
  }
  getValues = () => ({
    title: this.state.title,
    description: this.state.description,
    links: this.state.links,
    disabled: this.state.disabled,
    icon: this.state.icon,
    id: this.props.id
  })
  setRowValueByIndex = ({ name, value, index }) => {
    this.setState(state => ({
      links: [
        ...state.links.slice(0, index),
        { ...state.links[index], [name]: value },
        ...state.links.slice(index + 1)
      ]
    }))
  }
  setTitle = value => {
    this.setState({
      title: value
    })
  }
  setDescription = value => {
    this.setState({
      description: value
    });
  }
  addNewLink = () => {
    this.setState(state => ({
      links: [...state.links, { label: "", href: "", targetBlank: false }],
      newIconIndex: state.links.length
    }))
  }
  closeIconMenu = () => {
    this.setState({ iconMenuOpen: false })
  }
  openIconMenu = () => {
    this.setState({
      iconMenuOpen: true,
      iconMenuAnchor: this.iconMenuButton
    })
  }
  setIcon = ({ value }) => {
    this.setState({
      icon: value
    })
  }
  insertAbove = index => {
    this.setState(state => ({
      links: [
        ...state.links.slice(0, index),
        { label: "", href: "", targetBlank: false },
        ...state.links.slice(index)
      ],
      newIconIndex: index
    }))
  }
  insertBelow = index => {
    this.setState(state => ({
      links: [
        ...state.links.slice(0, index + 1),
        { label: "", href: "", targetBlank: false },
        ...state.links.slice(index + 1)
      ],
      newIconIndex: index + 1
    }))
  }
  deleteLink = index => {
    this.setState(state => ({
      links: [...state.links.slice(0, index), ...state.links.slice(index + 1)]
    }))
  }
  clearNewIcon = () => {
    this.setState({
      newIconIndex: null
    })
  }
  setDisabled = value => {
    this.setState({ disabled: !value })
  }
  openDeleteDialog = () => {
    this.setState({
      deleteDialogOpen: true
    })
  }
  closeDeleteDialog = () => {
    this.setState({
      deleteDialogOpen: false
    })
  }
  handleKeyDown = (e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this.openIconMenu()
    }
  }
  render() {
    return (
      <div className="container-fluid wizard home-category-modal">
        <div className="row">
          <div className="col-12 title-row">
            <DumbField label="Icon">
              <div
                tabIndex="0"
                onClick={this.openIconMenu}
                onKeyDown={this.handleKeyDown}
                aria-label="Change Icon"
                className="icon-menu-wrapper"
                ref={ref => {
                  this.iconMenuButton = ref
                }}
              >
                {ICONS[this.state.icon]}
              </div>
            </DumbField>
            <DumbField fieldId={`category-${this.props.id}`} className="title-wrapper" label="Category title">
              <TextInput
                fieldId={`category-${this.props.id}`}
                value={this.state.title}
                onChange={this.setTitle}
                width="100%"
              />
            </DumbField>
            <DumbField fieldId={`subtitle-${this.props.id}`} className="description-wrapper" label="Subtitle">
              <TextInput
                fieldId={`subtitle-${this.props.id}`}
                value={this.state.description}
                onChange={this.setDescription}
                width="100%"
              />
            </DumbField>
            <div className="check-wrapper">
              <Checkbox
                value={!this.state.disabled}
                onChange={this.setDisabled}
                label="Enabled"
                fieldId='disabled-check'
              />
            </div>
            {
              this.props.deletable ?
                <div className="align-right">
                  <button className="btn btn-danger btn-raised" onClick={this.openDeleteDialog}>
                    Delete Category
                  </button>
                </div>
                : null
            }
          </div>
        </div>
        <div className="links row">
          {this.state.links.map(
            (link, i) =>
              link.type === "separator" ? (
                <EditSeparator index={i} key={i} />
              ) : (
                  <EditLink
                    onChange={this.setRowValueByIndex}
                    insertAbove={this.insertAbove}
                    insertBelow={this.insertBelow}
                    deleteLink={this.deleteLink}
                    clearNewIcon={this.clearNewIcon}
                    isNew={this.state.newIconIndex === i}
                    {...link}
                    index={i}
                    key={i}
                  />
                )
          )}
          <button type="button" onClick={this.addNewLink} className="add-link custom-focus">
            Add new link
          </button>
        </div>
        <FloatingMenu
          className="home-icon-menu"
          isOpen={this.state.iconMenuOpen}
          alignTo={this.state.iconMenuAnchor}
          align="right"
          onRequestClose={this.closeIconMenu}
          options={[
            { value: "business", label: ICONS.business, onClick: this.setIcon },
            { value: "shield", label: ICONS.shield, onClick: this.setIcon },
            { value: "tools", label: ICONS.tools, onClick: this.setIcon },
            { value: "capital", label: ICONS.capital, onClick: this.setIcon },
            { value: "charity", label: ICONS.charity, onClick: this.setIcon },
            { value: "stamp", label: ICONS.stamp, onClick: this.setIcon }
          ]}
        />
        {
          this.state.deleteDialogOpen &&
          <Portal isOpened={this.state.deleteDialogOpen}>
            <ConfirmDialog
              closeModal={this.closeDeleteDialog}
              message="Are you sure you want to delete this Category?"
              buttons={[
                { label: "No", onClick: this.closeDeleteDialog, className: "btn-default" },
                { label: "Yes", onClick: this.props.onRequestDelete, className: "btn-danger" }
              ]}
              modalStyle={{ borderRadius: 3 }}
            />
          </Portal>
        }
      </div>
    )
  }
}

export class EditLink extends React.Component {
  state = {
    menuOpen: false,
    menuAnchor: null
  }
  onChange = (value, e) => {
    this.props.onChange({
      name: e.target.name,
      value,
      index: this.props.index
    })
  }
  setTargetBlank = (value, e) => {
    this.props.onChange({
      name: "targetBlank",
      value,
      index: this.props.index
    })
  }
  openMenu = () => {
    this.setState({
      menuOpen: true,
      menuAnchor: this.menuButton
    })
  }
  closeMenu = () => {
    this.setState({ menuOpen: false })
  }
  insertAbove = () => {
    this.props.insertAbove(this.props.index)
  }
  insertBelow = () => {
    this.props.insertBelow(this.props.index)
  }
  startDeleteAnimation = () => {
    this.setState({
      deleting: true
    })
  }
  onAnimationEnd = () => {
    if (this.state.deleting) {
      this.setState({ deleting: false })
      this.props.deleteLink(this.props.index)
    } else if (this.props.isNew) {
      this.props.clearNewIcon()
    }
  }
  render() {
    const { label, href, themeColor = '', themeable, targetBlank = false, index, isNew } = this.props
    return (
      <div
        className={`col-12 link-row ${isNew ? "animate-new" : ""} ${
          this.state.deleting ? "animate-delete" : ""
          }`}
        onAnimationEnd={this.onAnimationEnd}
      >
        <button
          aria-haspopup="true"
          title="Options"
          onClick={this.openMenu}
          className="menu-button"
          ref={ref => {
            this.menuButton = ref
          }}
        >
          <DotMenuIcon />
        </button>
        <DumbField fieldId={`display-${index}`} label="Display text">
        <TextInput fieldId={`display-${index}`} value={label} name="label" onChange={this.onChange} />
        </DumbField>
        <DumbField fieldId={`url-${index}`} className="url" label="URL">
          <TextInput
            fieldId={`url-${index}`}
            value={href}
            placeholder="https://"
            name="href"
            onChange={this.onChange}
          />
        </DumbField>
        {
          themeable &&
          <DumbField fieldId={`theme-${index}`} className="url" label="Theme Color">
            <Select
              fieldId={`theme-${index}`}
              value={themeColor}
              name="themeColor"
              options={[
                { value: '', label: '[Default]' },
                { value: 'secondary', label: 'Secondary' }
              ]}
              onChange={this.onChange}
              onBlur={() => { }}
            />
          </DumbField>
        }
        <div className="new-tab-wrapper">
          <Checkbox
            label="Open in new tab/window"
            value={targetBlank}
            name={`targetBlank${index}`}
            onChange={this.setTargetBlank}
            fieldId={`target-${index}`}
          />
        </div>
        <FloatingMenu
          className="home-edit-menu"
          isOpen={this.state.menuOpen}
          alignTo={this.state.menuAnchor}
          align="right"
          onRequestClose={this.closeMenu}
          options={[
            {
              label: (
                <span>
                  <CaretUpIcon />Insert above
                </span>
              ),
              onClick: this.insertAbove
            },
            {
              label: (
                <span>
                  <CaretDownIcon />Insert below
                </span>
              ),
              onClick: this.insertBelow
            },
            {
              label: (
                <span className="danger-text">
                  <TrashIcon />Delete link
                </span>
              ),
              onClick: this.startDeleteAnimation
            }
          ]}
        />
      </div>
    )
  }
}

const EditSeparator = ({ index }) => (
  <div className="col-12">
    <Separator categoryId={`modal-${index}`} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Home/Home.js